const env = {
    BASE_URL: 'https://dummyapi.io/data/api/',
    API_KEY : '60e48ad31b60a340c348c4a0'
}

export default env;


// WEBPACK FOOTER //
// ./src/local.js